import React from 'react'
import { JobSeekerProgressBanner } from '../../../components/Banner/ProgressBanner/JobSeekerProgressBanner'
import { StepContainer } from '../../../components/Steps/StepContainer'
import styles from './JobSeekerEdit.module.css'
import { useStepHandler } from '../../../hooks/useStepHandler'
import {
    FormValues,
    DisplayValues,
} from '../../../components/Store/reducers/formReducer/types'
import { JobSeekerData, JobSeekerEditPageProps } from './types'
import {
    EXPERIENCE_TO_EXPERIENCE_YEARS_MAP,
    SITUATION_NUMBER_TO_STRING_MAP,
    SITUATION_STRING_TO_DISPLAY_MAP,
    SITUATION_NUMBER_TO_DISPLAY_MAP,
} from './constants'

const convertExperienceToExperienceYears = (
    experience: string | null
): string => {
    if (!experience) return ''

    return EXPERIENCE_TO_EXPERIENCE_YEARS_MAP[experience] || ''
}

const convertSituationToFormValue = (situation: number | string): string => {
    if (typeof situation === 'string') {
        return situation
    }
    if (typeof situation === 'number') {
        return SITUATION_NUMBER_TO_STRING_MAP[situation] || ''
    }
    return ''
}

const convertJobSeekerToFormValues = (
    jobSeeker: JobSeekerData
): Partial<FormValues> => {
    return {
        firstName: jobSeeker.firstname || '',
        lastName: jobSeeker.lastname || '',
        firstNameKana: '',
        lastNameKana: '',
        email: jobSeeker.email || '',
        tel: jobSeeker.phone_number || '',
        prefecture: jobSeeker.prefecture_id || null,
        situation: convertSituationToFormValue(jobSeeker.situation),
        birthday: '',
        experienceYears: convertExperienceToExperienceYears(
            jobSeeker.experience
        ),
        lineId: jobSeeker.line_id || null,
    }
}

const convertSituationToDisplayValue = (situation: number | string): string => {
    if (typeof situation === 'string') {
        return SITUATION_STRING_TO_DISPLAY_MAP[situation] || ''
    }
    if (typeof situation === 'number') {
        return SITUATION_NUMBER_TO_DISPLAY_MAP[situation] || ''
    }
    return ''
}

const convertJobSeekerToDisplayValues = (
    jobSeeker: JobSeekerData
): Partial<DisplayValues> => {
    return {
        name: `${jobSeeker.lastname || ''} ${jobSeeker.firstname || ''}`.trim(),
        nameKana:
            `${jobSeeker.lastname_kana || ''} ${jobSeeker.firstname_kana || ''}`.trim(),
        email: jobSeeker.email || '',
        tel: jobSeeker.phone_number || '',
        situation: convertSituationToDisplayValue(jobSeeker.situation),
        lineId: jobSeeker.line_id || '',
    }
}

const JobSeekerEditPage = ({
    webhookUrl,
    jobSeekerData,
}: JobSeekerEditPageProps) => {
    const initialFormState = convertJobSeekerToFormValues(jobSeekerData)
    const initialDisplayState = convertJobSeekerToDisplayValues(jobSeekerData)

    const {
        stepState,
        displayState,
        formState,
        handleNext,
        handlePrev,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        setStepStatus,
        setSkippedSteps,
        isBlocking,
    } = useStepHandler({
        initialFormState,
        initialDisplayState,
    })

    return (
        <div>
            <JobSeekerProgressBanner
                currentStep={stepState.currentStep.currentStep}
            />
            <div className={styles.steps}>
                <StepContainer
                    stepState={stepState}
                    displayState={displayState}
                    formState={formState}
                    stepBoolean={stepState.stepStatus}
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                    setFormValue={setFormValue}
                    updateUserResume={updateUserResume}
                    setDisplayValue={setDisplayValue}
                    setStepStatus={setStepStatus}
                    setSkippedSteps={setSkippedSteps}
                    webhook={webhookUrl}
                    isBlocking={isBlocking}
                    registerToken={jobSeekerData.register_token}
                />
            </div>
        </div>
    )
}

export default JobSeekerEditPage
